import * as React from 'react';
import {observer} from 'mobx-react';
import {colorBackground} from '../theme/color';
import {style} from 'typestyle';
import {px} from 'csx';
import {betweenJustified, center, centerCenter, horizontal, vertical} from 'csstips';
import {PageCheckoutHeaderMenu} from './page-checkout-header-menu';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import {StripeLogo} from './stripe-logo';

export interface PageCheckoutHeaderModel {
  step: number;
  total: number | string;
  currency: string;
}

export interface PageCheckoutHeaderProps {
  model: PageCheckoutHeaderModel;
  onSelectStep(step: number): void;
  i18n?: {
    title: string;
    total: string;
  }
}

const DEFAULT_I18N = {
  title: 'Checkout',
  total: 'total'
};

export const PageCheckoutHeader = observer<PageCheckoutHeaderProps>(
  ({ model, onSelectStep, i18n = DEFAULT_I18N }) => (
    <div className={styles.container}>
      <div className={styles.toolbar}>
        <PageCheckoutHeaderMenu
          model={model}
          onSelectStep={onSelectStep}
        />
        <div className={styles.total}>
          <StripeLogo type="dark"/>
        </div>
      </div>
    </div>
  )
);

const toolbarHeightDesktop = px(70);
const toolbarHeightMobile = px(50);

const styles = {
  container: style(
    {
      ...vertical,
      padding: 0,
      borderBottom: `1px solid ${colorBackground.fade(0.7).toString()}`,
    },
    mediaMobileOnly({
      $nest: {
        '& h1': {
          padding: `${toolbarHeightMobile} 1rem 0`
        }
      }
    }),
    mediaTablet({
      $nest: {
        '& h1': {
          padding: `${toolbarHeightDesktop} 3rem 0`
        }
      }
    })
  ),
  toolbar: style({
    ...horizontal,
    ...center,
    ...betweenJustified,
    padding: '0 1rem',
    height: toolbarHeightDesktop,
    ...mediaMobileOnly({
      height: toolbarHeightMobile
    })
  }),
  total: style({
    ...centerCenter
  })
}